// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .multipe-uploader-area {
  background: var(--black1);
  border-color: var(--black6);
}
.dark .multipe-uploader-thumb {
  background: var(--black1);
  border-color: var(--black6);
}

.multipe-uploader {
  display: flex;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.multipe-uploader-remove-icon {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.multipe-uploader-placeholder {
  margin: 0;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  margin-top: 0.75rem;
  color: var(--black5);
}
.multipe-uploader-placeholder span {
  color: var(--purple6);
  font-weight: 600;
}
.multipe-uploader-placeholder div {
  margin-top: 0.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: var(--black4);
}
.multipe-uploader-warning {
  color: var(--red6);
  margin: 0;
}
.multipe-uploader-area {
  border: 2px dashed var(--black1);
  padding: 1.5rem;
  border-radius: 0.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
  width: 100%;
}
@media (max-width: 768px) {
  .multipe-uploader-area {
    padding: 1rem;
  }
}
.multipe-uploader-area:first-child {
  margin-top: 0;
}
.multipe-uploader-area:hover {
  border-color: var(--black5);
}
.multipe-uploader-area:focus {
  outline: none;
  border-color: var(--purple6);
}
.multipe-uploader-area svg {
  margin: 0 auto;
}
.multipe-uploader-thumb {
  margin: 0.25rem 0;
  padding: 1rem;
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.multipe-uploader-thumb:last-child {
  margin-bottom: 0;
}
.multipe-uploader-thumb .paylixecommerce-table-actions-modal {
  width: 9rem;
}
@media (max-width: 768px) {
  .multipe-uploader-thumb .paylixecommerce-table-actions-modal {
    width: auto;
  }
  .multipe-uploader-thumb .paylixecommerce-table-actions-modal span {
    display: flex !important;
  }
}
.multipe-uploader-thumb.default-image {
  border-color: var(--purple6);
}
.multipe-uploader-thumb-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: calc(100% - 1rem - 3rem);
}
.multipe-uploader-thumb-info-details {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  flex-direction: column;
  width: calc(100% - 2rem);
  height: 100%;
}
.multipe-uploader-thumb-image {
  width: 3rem;
  height: 3rem;
  min-width: 3rem;
  border-radius: 0.5rem;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  position: relative;
}
.multipe-uploader-thumb-image .default-icon {
  position: absolute;
  top: -0.35rem;
  right: -0.35rem;
  border-radius: 100%;
  background-color: var(--orange4);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.75rem;
  height: 0.75rem;
  border: 2px solid white;
  box-sizing: content-box;
}
.multipe-uploader-thumb-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
}
.multipe-uploader-thumb-name {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
@media (max-width: 340px) {
  .multipe-uploader-thumb-name {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 80px;
  }
}
.multipe-uploader-thumb-size {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black4);
}`, "",{"version":3,"sources":["webpack://./client/components/fields/multipe-upload/style.scss"],"names":[],"mappings":"AAEQ;EACI,yBAAA;EACA,2BAAA;AADZ;AAGQ;EACI,yBAAA;EACA,2BAAA;AADZ;;AAMA;EACI,aAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAHJ;AAKI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAMI;EACI,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAJR;AAMQ;EACI,qBAAA;EACA,gBAAA;AAJZ;AAOQ;EACI,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AALZ;AASI;EACI,kBAAA;EACA,SAAA;AAPR;AAUI;EACI,gCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AARR;AAUQ;EAXJ;IAYQ,aAAA;EAPV;AACF;AASQ;EACI,aAAA;AAPZ;AAUQ;EACI,2BAAA;AARZ;AAWQ;EACI,aAAA;EACA,4BAAA;AATZ;AAYQ;EACI,cAAA;AAVZ;AAcI;EACI,iBAAA;EACA,aAAA;EACA,+BAAA;EACA,4CAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAZR;AAcQ;EACI,gBAAA;AAZZ;AAeQ;EACI,WAAA;AAbZ;AAeY;EAHJ;IAIQ,WAAA;EAZd;EAcc;IACI,wBAAA;EAZlB;AACF;AAgBQ;EACI,4BAAA;AAdZ;AAiBQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,+BAAA;AAfZ;AAiBY;EACI,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;AAfhB;AAmBQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAjBZ;AAmBY;EACI,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;AAjBhB;AAoBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;AAlBhB;AAsBQ;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AApBZ;AAsBY;EARJ;IASQ,uBAAA;IACA,gBAAA;IACA,WAAA;EAnBd;AACF;AAsBQ;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AApBZ","sourcesContent":[".dark {\n    .multipe-uploader {\n        &-area {\n            background: var(--black1);\n            border-color: var(--black6);\n        }\n        &-thumb {\n            background: var(--black1);\n            border-color: var(--black6);\n        }\n    }\n}\n\n.multipe-uploader {\n    display: flex;\n    width: 100%;\n    margin: 0 auto;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    &-remove-icon {\n        width: 2rem;\n        height: 2rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    &-placeholder {\n        margin: 0;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 17px;\n        text-align: center;\n        margin-top: .75rem;\n        color: var(--black5);\n\n        span {\n            color: var(--purple6);\n            font-weight: 600;\n        }\n\n        div {\n            margin-top: .5rem;\n            font-family: 'Inter';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 15px;\n            text-align: center;\n            color: var(--black4);\n        }\n    }\n\n    &-warning {\n        color: var(--red6);\n        margin: 0;\n    }\n\n    &-area {\n        border: 2px dashed var(--black1);\n        padding: 1.5rem;\n        border-radius: .5rem;\n        text-align: center;\n        cursor: pointer;\n        transition: all .2s ease;\n        margin-top: .5rem;\n        margin-bottom: .25rem;\n        width: 100%;\n\n        @media (max-width: 768px) {\n            padding: 1rem;\n        }\n\n        &:first-child {\n            margin-top: 0;\n        }\n\n        &:hover {\n            border-color: var(--black5);\n        }\n\n        &:focus {\n            outline: none;\n            border-color: var(--purple6);\n        }\n\n        svg {\n            margin: 0 auto;\n        }\n    }\n\n    &-thumb {\n        margin: .25rem 0;\n        padding: 1rem;\n        border: 1px solid var(--black2);\n        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n        border-radius: .5rem;\n        display: flex;\n        flex-wrap: wrap;\n        width: 100%;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        .paylixecommerce-table-actions-modal {\n            width: 9rem;\n\n            @media (max-width: 768px) {\n                width: auto;\n\n                span {\n                    display: flex !important;\n                }\n            }\n        }\n\n        &.default-image {\n            border-color: var(--purple6);\n        }\n\n        &-info {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            flex-wrap: wrap;\n            width: calc(100% - 1rem - 3rem);\n\n            &-details {\n                display: flex;\n                align-items: flex-start;\n                justify-content: space-around;\n                flex-direction: column;\n                width: calc(100% - 2rem);\n                height: 100%;\n            }\n        }\n\n        &-image {\n            width: 3rem;\n            height: 3rem;\n            min-width: 3rem;\n            border-radius: .5rem;\n            margin-right: 1rem;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            overflow: visible;\n            position: relative;\n\n            .default-icon {\n                position: absolute;\n                top: -0.35rem;\n                right: -0.35rem;\n                border-radius: 100%;\n                background-color: var(--orange4);\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                width: 0.75rem;\n                height: 0.75rem;\n                border: 2px solid white;\n                box-sizing: content-box;\n            }\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n                border-radius: .5rem;\n            }\n        }\n\n        &-name {\n            font-family: 'Inter';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 17px;\n            color: var(--black9);\n\n            @media (max-width: 340px) {\n                text-overflow: ellipsis;\n                overflow: hidden;\n                width: 80px;\n            }\n        }\n\n        &-size {\n            font-family: 'Inter';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 15px;\n            color: var(--black4);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
